import { useEffect } from "react";

const useLegacyWillUnmount = (callback: () => void): void => {
  useEffect(() => {
    return () => {
      callback();
    };
  }, []);
};

export { useLegacyWillUnmount };
